;"use strict";


$(window).on("load", function (e){
    if($(".product-page .tabs").length){
        $(".product-page .tabs > li").each(function (i, elem){
            if($(elem).find("a").text() == "3D model" || $(elem).find("a").text() == "3D Model"){
                $("body").addClass("product_has__3D");
                $(this).addClass("tab_3D__model");
            }
        });
    }

    $(document).on("click", "#anchor_to_3D", function (e){
        $("html, body").animate({
            scrollTop: $('.tabs_wrap__row').offset().top - 60
        }, 1000);
        $('ul.tabs > li.tab_3D__model a').trigger('click');
    });

});